import { Icon16Cancel, Icon16Done, Icon20SmileAddOutline, Icon28Hearts2Outline } from '@vkontakte/icons';
import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as IconUnlimitedAutoupload } from 'img/icons/unlimited-autoupload-16.svg';
import React from 'react';
import type { TariffByModalTab } from 'reactApp/ui/TariffsModal/TariffsModalContent.types';

import styles from './FeaturesListMobile.css';

interface FeaturesListMobileProps {
    tariff: TariffByModalTab | null;
    className?: string;
    qaId?: string;
}

export const FeaturesListMobile = ({ tariff, className, qaId }: FeaturesListMobileProps) => {
    const { features } = { ...tariff };

    return (
        <ul className={classNames(styles.wrapper, className)} data-qa-id={`${qaId}-features`}>
            {features &&
                features.slice(0, 4).map((feature, index) => (
                    <li key={feature.key} className={styles.line}>
                        {!feature.noIcon && (
                            <div
                                className={classNames({
                                    [styles.icon_accent]: !feature.disabled,
                                })}
                            >
                                {feature.icon && feature.usePropsIcon ? (
                                    feature.icon
                                ) : feature.icon || feature.disabled ? (
                                    <Icon16Cancel />
                                ) : feature.key === 'unlimit-autoupload' ? (
                                    <IconUnlimitedAutoupload />
                                ) : feature.key === 'family-tariff' ? (
                                    <Icon20SmileAddOutline width={16} height={16} />
                                ) : feature.key === 'family-folders-albums' ? (
                                    <Icon28Hearts2Outline width={16} height={16} />
                                ) : (
                                    <Icon16Done />
                                )}
                            </div>
                        )}
                        <Text
                            className={classNames(styles.text, {
                                [styles.text_accent]: feature.accent,
                            })}
                            data-qa-id={`feature-${index}`}
                        >
                            {feature.text}
                        </Text>
                    </li>
                ))}
        </ul>
    );
};
